import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Link } from "gatsby";

export const BreadcrumbLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    color: ${theme.colors.blues[100]};
  }
`;

export const BreadcrumbsWrap = styled.div`
  box-sizing: border-box;
  max-width: ${theme.maxWidth};
  margin: 1rem auto;
  font-size: ${theme.fontSizes[0]};
  color: ${theme.colors.darkBlues[75]};
  span + span:before {
    content: "  /  ";
    white-space: pre;
  }
`;

export const BreadcrumbsBase = styled.div`
  padding: 0 ${theme.spacing[4]};

  ${theme.largerThan["2xl"]} {
    padding: 0;
  }
`;
